<script setup lang="ts">
  import { testIds } from '@gat-ship/types'
  import { type StakeholderContact } from '@gat-ship/types'
  import { IconTrash } from '@gat-ship/icons'
  import { useContactProvider } from '../../../../composables/useStakeholderContacts'
  import { useStakeholderPermissions } from '@gat-ship/stakeholders'
  import { DropdownMenuItem } from '@gat-ship/vue-components'

  withDefaults(
    defineProps<{
      contact: StakeholderContact
      label?: string
    }>(),
    {
      label: 'Delete Contact'
    }
  )

  const { commands } = useContactProvider()
  const { canRemoveContact } = useStakeholderPermissions()
</script>

<template>
  <DropdownMenuItem
    v-if="canRemoveContact()"
    :data-testid="testIds.stakeholders.contacts.actions.deleteContactPerson"
    @click="commands.deleteContact(contact)"
  >
    <IconTrash class="size-4" />
    {{ label }}
  </DropdownMenuItem>
</template>
